import { render, staticRenderFns } from "./Vendasgrupos.vue?vue&type=template&id=4e9aafd9&"
import script from "./Vendasgrupos.vue?vue&type=script&lang=js&"
export * from "./Vendasgrupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports